<template lang="pug">
  v-layout.column(:width="width" :data-test="`${column}-header`")
    v-flex.xs12
      v-layout.row.align-center.mt-2
        v-layout(:class="{ 'justify-center': align === 'center' }")
          .title.table-header {{translateHeaders ? $t(label) : label}}
        div
          button(@click="rcDebounce(changeSort)" v-if="sortable && displaySortable")
            v-icon(
              v-if="(pagination.sortBy === column) && !pagination.descending"
              class="material-icons"
            ) arrow_upward
            v-icon(
              v-else
              class="material-icons"
            ) arrow_downward
    v-flex.xs12.selectAll(v-if="displayFilters")
      v-checkbox(
        v-if="type === 'selection'"
        :input-value="all"
        :indeterminate="indeterminate"
        color="primary"
        primary
        hide-details
        @click.native="emitToggleAll"
      )
    v-flex.xs12.filters(v-if="displayFilters")
      v-layout(v-if="filters")
        v-flex.xs4(v-if="filters.operands !== undefined && filters.operands.length > 1")
          v-select.oppSelect(
            @change="emitFilterUpdate"
            :items="filters.operands"
            :value="operand"
            single-line
          )
        v-flex(
          :class=`{ xs8: filters.operands !== undefined && filters.operands.length > 1,
          xs12: filters.operands !== undefined && filters.operands.length > 1 }`
        )
          v-text-field.pt-0.mt-0(
            @input="value => { emitFilterUpdate(value, 200) }"
            :ref="filters.type"
            v-if="filters.type === 'text'"
            :value="value"
            hide-details
            :data-test="`${column}-filter`"
          )
          v-checkbox.cb-type-filter(
            @change="value => { call(value, !!filters.customHandler ? filters.customHandler : 'emitFilterUpdate') }"
            :ref="filters.type"
            v-if="filters.type === 'checkbox'"
            :value="value"
            color="primary"
            hide-details
            :data-test="`${column}-filter`"
          )
          v-select.pt-0.mt-0(
            @change="value => { call(value, !!filters.customHandler ? filters.customHandler : 'emitFilterUpdate') }"
            v-if="filters.type === 'select'"
            :ref="filters.type"
            :items="filterValues"
            :value="filters.default || ''"
            :clearable="!!filters.clearable"
            hide-details
            item-text="label"
            item-value="value"
            no-data-text="Aucun filtre"
            :data-test="`${column}-filter`"
          )
            template(slot="selection" slot-scope="props")
              span.v-select__selection.grey--text.text--darken-2 {{ props.item.label }}
          v-select.pt-0.mt-0(
            @change="emitFilterUpdate"
            v-if="filters.type === 'select_multiple'"
            :ref="filters.type"
            :items="filterValues"
            :item-text="this.filters.label || 'name'"
            :item-value="this.filters.key || 'id'"
            multiple
            :value="value"
            hide-details
            no-data-text="Aucun filtre"
            :data-test="`${column}-filter`"
          )
            template(slot="selection" slot-scope="props")
              span.grey--text.text--darken-2(v-if="props.index === 0") {{ selectedFilters }}/{{ filterValues.length }} séléctionnés
          v-autocomplete.pt-0.mt-0.grey--text(
            @change="emitFilterUpdate"
            v-if="filters.type === 'autocomplete'"
            :ref="filters.type"
            :items="filterValues"
            :item-text="this.filters.label || 'name'"
            :item-value="this.filters.key || 'id'"
            :value="value"
            multiple
            hide-details
            single-line
            no-data-text="Aucun filtre"
            :data-test="`${column}-filter`"
          )
            template(slot="selection" slot-scope="props")
              span.grey--text.text--darken-2(v-if="props.index === 0") {{ selectedFilters }}/{{ filterValues.length }} séléctionnés
          rc-categorized-type-search(v-if="filters.type === 'categorized_type_search'" @change="emitFilterUpdate")
</template>

<script>
import rcDebounce from '@/mixins/rcDebounce';
import RcCategorizedTypeSearch from './RcCategorizedTypeSearch.vue'

export default {
  name: 'RcTableHeader',
  i18nOptions: { namespaces: 'headers' },
  components: {
    RcCategorizedTypeSearch,
  },
  props: {
    label: String,
    column: String,
    bdColumn: String,
    sortable: Boolean,
    pagination: Object,
    filters: Object,
    translateHeaders: Boolean,
    type: String,
    filterValues: [Array, String],
    all: [Boolean, Number],
    indeterminate: Boolean,
    width: String,
    prevValues: {
      type: Array,
      default: () => [],
    },
    metadata: {
      type: Object,
      default: () => {},
    },
    align: {
      type: String,
      default: 'left',
    },
    displayFilters: {
      type: Boolean,
      default: true,
    },
    displaySortable: {
      type: Boolean,
      default: true,
    },
  },
  mixins: [
    rcDebounce,
  ],
  data() {
    return {
      operand: this.filters ? this.filters.operands[0] : null,
      value: '',
    };
  },
  computed: {
    selectedFilters() {
      const filter = this.prevValues.find(x => x.field === this.filters.field);
      return filter.value.length || filter.value.split(',').length;
    },
  },
  methods: {
    call(value, method) {
      this[method](value);
    },
    emitToggleAll() {
      this.$emit('toggleAll', this.indeterminate);
    },
    emitFilterUpdate(value, wait = 0) {
      if (['select', 'select_multiple', 'autocomplete'].includes(this.filters.type)) {
        if (Array.isArray(value)) {
          if (!!value.length) {
            value = value.join(',');
          } else {
            value = null;
          }
        }
        if (value === null) {
          this.value = [];
          this.$emit('filterUpdate', this.filters.field || this.column, {});
        } else {
          const params = [
            this.filters.field || this.column,
            {
              operand: this.filters.customOperand ? value : this.operand,
              value: ['select_multiple', 'autocomplete'].includes(this.filters.type) ? value.split(',') : value,
              entity: this.filters.entity,
            },
          ];
          this.$emit('filterUpdate', ...params);
        }
      }
      else if (value !== this.value) {
        this.value = value;
        this.rcDebounce(() => {
          this.$emit('filterUpdate', this.filters.field || this.column, { operand: this.filters.customOperand ? this.value : this.operand, value: this.value, entity: this.filters.entity });
        }, wait);
      }
    },
    toggleSendOrphans(value) {
      switch (value) {
        case 'noOrphans':
          this.$emit('editBodyParams', true, 'orphans', false);
          break;
        case 'onlyOrphans':
          this.$emit('editBodyParams', true, 'orphans', true);
          break;
        default:
          this.$emit('editBodyParams', false, 'orphans', false);
          break;
      }
      this.$emit('get');
    },
    changeSort() {
      this.$emit('changeSort', this.column);
    },
  },
};
</script>

<style lang="scss">
  .selectAll {
    height: .1em;
  }
  .filters {
    height: 4em;
    .v-input {
      font-size: 14px;
    }
    .cb-type-filter {
      margin-right: auto;
      margin-left: auto;
      display: block;
      .v-input--selection-controls__input {
        margin-right: 0px;
      }
    }
    .v-text-field__slot {
      input {
        color: #616161!important;
      }
    }
    .v-select__selections {
      white-space: nowrap;
      overflow-x: hidden;
      text-overflow: ellipsis;
    }
    .oppSelect {
      .v-select__selections {
        input {
          display: none;
        }
        .v-select__selection {
          overflow: hidden;
        }
      }
    }
  }
</style>
